import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockPersonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock_person"}/>
}
